// extracted by mini-css-extract-plugin
export default {"usefulQuestions":"vLDYA gobPa"};